import { render, staticRenderFns } from "./LearnVsCreatorProductPrompt.vue?vue&type=template&id=22df13a8&scoped=true"
import script from "./LearnVsCreatorProductPrompt.vue?vue&type=script&lang=js"
export * from "./LearnVsCreatorProductPrompt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22df13a8",
  null
  
)

export default component.exports